module.exports = __webpack_public_path__ + "img/close.958a0063.png";